import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { bindActionCreators } from 'redux';
import * as appSidebarActions from './../../appSidebar/actions';
import Axios from './../../common/helpers/axiosUtil';

class PAChatbot extends Component {
  enablePA = false;

  constructor(props) {
    super(props);
    this.state = {
      enableLiveChat: false,
      reconnectLP: this.props.enableLPReconnect ? this.getConversationHeaderData('reconnectLP') || false : false,
      popupACA: true,
    };
  }

  getUserProfile() {
    return this.props.userProfile;
  }

  getAccessLevel() {
    const accessLevel = this.getUserProfile()?.accessLevel;
    return accessLevel;
  }

  getUserType() {
    const userType = this.getUserProfile()?.userType;
    return userType;
  }

  getDecodedLocalStorage(name) {
    const localData = window.localStorage.getItem(name) || '';
    if (localData !== '') {
      try {
        const decoded = JSON.parse(atob(localData));
        return decoded
      } catch(e) {
        return {};
      }
    }
    return {};
  }

  setConversationHeaderData(field, value) {
    try {
      const convHeader = this.getDecodedLocalStorage('conversationHeader');
      convHeader[field] = value;
      const encodedConvHeader = btoa(JSON.stringify(convHeader));
      window.localStorage.setItem('conversationHeader', encodedConvHeader);
    } catch (e) {
      return null
    }
  }

  getConversationHeaderData(field) {
    try {
      const decodedConvHeader = this.getDecodedLocalStorage('conversationHeader');
      return decodedConvHeader?.[field];
    } catch (e) {
      return null;
    }
  }


  setGACAProps(field, value) {
    window.gAcaProps = Object.assign({}, window.gAcaProps, {
      [field]: value,
    });
    window.sessionStorage.setItem('gAcaProps', JSON.stringify(window.gAcaProps));
  }

  resetReconnectLP() {
    this.setState({ reconnectLP: false });
    this.setConversationHeaderData('lpConversationId', '');
    this.setGACAProps('lpConversationId', '')
    this.setConversationHeaderData('reconnectLP', false);
    this.setGACAProps('reconnectLP', false)
  }

  callLpStatusApi() {
    const URL = '/apps/ptb/api/chatbot/lpstatus';
    Axios.post(URL)
      .then(data => {
        if ((data && data?.status === 'ACTIVE') || this.getConversationHeaderData('reconnectLP')) {
          this.setState({ reconnectLP: true });
          this.setGACAProps('reconnectLP', true);
          this.setConversationHeaderData('reconnectLP', true);
          this.setGACAProps('lpConversationId', this.getConversationHeaderData('lpConversationId') || null);
        } else {
          this.resetReconnectLP();
        }
      })
      .catch(err => {
        return err;
      });
  }

  componentDidMount() {
    if (this.props.enableLPReconnect) {
      // Check for existing LP chat session
      this.callLpStatusApi();
    }
    if (this.props.passUserDetails) {
      window.gAcaProps = Object.assign({}, window.gAcaProps, {
        encryptedTaxId: this.props.encryptedTaxId,
        loggedInUserId: this.props.loggedInUserId,
        isSimulation: this.props.isSimulation,
        encryptedUserID: this.props.encryptedUserID,
        accessLevel: this.getAccessLevel(),
        userType: this.getUserType(),
      });
    } else {
      window.gAcaProps = Object.assign({}, window.gAcaProps, {
        isSimulation: this.props.isSimulation
      });
    }

    sessionStorage.setItem('gAcaProps', JSON.stringify(window.gAcaProps));
    this.registerDeeplinkHandler();
  }
  
  registerDeeplinkHandler() {
    window.addEventListener('message', event => {
      if (event.data && event.data.template && event.data.code === 'OPEN_SIDEBAR') {
        this.props.showSidebar({
          template: 'CHATCONTEXTHELPER',
          templateData: event.data || null,
          customHeader: {
            title: (
              <div className="row sidebarHeader fright">
                <i
                  className={`fa fa-angle-right dash-icons sgQuick`}
                  aria-hidden="true"
                  onClick={() => {
                    this.props.hideSidebar();
                  }}
                ></i>
              </div>
            ),
            sidebarHeader: { backgroundColor: '#fff', borderRadius: 0 },
          },
          placement: 'left',
        });
      } else if (event.data?.code === 'DEEP_LINK') {
        const data = event.data;
        const action = data?.action;
        const args = data?.args || [];
        const fn = browserHistory?.[action];

        if (typeof fn === 'function' && Array.isArray(args)) {
          fn(...args);
        }
      } else if (event?.data?.type === 'closeChatWidget') {
        this.resetReconnectLP();
      }
    });
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.isAdminPage) {
      this.removeACAScripts();
    }
  }

  removeACAScripts = () => {
    // Remove ACA scripts
    for (let scriptFile of this.props.paChatbot.scriptListForACA) {
      const acaScriptFile = document.querySelectorAll(`script[src="${scriptFile}"]`);
      if (acaScriptFile && acaScriptFile.length !== 0) {
        document.head.removeChild(acaScriptFile[0]);
      }
    }

    // Remove ACA UI node
    const acaIframe = document.getElementById('aca--widget-frame');
    if (acaIframe) {
      acaIframe?.parentNode?.parentNode?.removeChild(acaIframe.parentNode);
    }
  };

  openACAUI = () => {
    window.postMessage('open_aca_chat', window.location.origin);
  };

  closeACAUI = () => {
    window.postMessage('close_aca_chat', window.location.origin);
  };

  checkPAShouldBeEnabled = () => {
    this.enablePA =
      (this.props.paChatbot?.enable &&
        this.props.bpUserInfo &&
        !this.props.isAdminPage &&
        this.props.enabledModules &&
        !this.props.isProspectiveBroker &&
        this.props.enabledModules.chatbotAccess !== false) ||
      false;

    if (
      this.enablePA &&
      this.props.enabledModules &&
      this.props.paChatbot?.toggle?.userModuleAccess &&
      this.props.paChatbot.toggle.userModuleAccess?.length !== 0
    ) {
      // check against user module access
      for (let userMods of this.props.paChatbot.toggle.userModuleAccess) {
        if (this.props.enabledModules[userMods] === false) {
          this.enablePA = false;
        }
      }
      // Check for usermodule enabled & state licence
      if (this.enablePA && this.props.paChatbot?.toggle?.statelicence && this.props.associatedStates.length !== 0) {
        // Disable PA initially and check if the user has state license
        this.enablePA = false;
        for (let state of this.props.paChatbot.toggle.statelicence) {
          if (this.props.associatedStates.indexOf(state) !== -1) {
            this.enablePA = true;
          }
        }
      }

      const profile = this.getUserProfile();
      if (!this.enablePA && profile && Array.isArray(this.props.enableChatbotForUser)) {
        for (const enableFor of this.props.enableChatbotForUser) {
          if (!enableFor.every(({ key, value }) => profile?.[key] === value)) {
            continue;
          }

          this.enablePA = true;
          break;
        }
      }
    }
  };

  renderACAUI = () => {
    // BPP-73948 - set global variable so that ACA Chat UI can access the values
    if (this.props.passUserDetails) {
      window.gAcaProps = Object.assign({}, window.gAcaProps, {
        encryptedTaxId: this.props.encryptedTaxId,
        loggedInUserId: this.props.loggedInUserId,
        isSimulation: this.props.isSimulation,
        encryptedUserID: this.props.encryptedUserID,
        reconnectLP: this.state.reconnectLP,
        accessLevel: this.getAccessLevel(),
        userType: this.getUserType(),
      });
    } else {
      window.gAcaProps = Object.assign({}, window.gAcaProps, {
        isSimulation: this.props.isSimulation,
        reconnectLP: this.state.reconnectLP,
      });
    }
    sessionStorage.setItem('gAcaProps', JSON.stringify(window.gAcaProps));
    for (let scriptFile of this.props.paChatbot.scriptListForACA) {
      if (document.querySelectorAll(`script[src="${scriptFile}"]`).length === 0) {
        window.loadScript(scriptFile);
      }
    }

    // Set new user / returning user (after a minimum of 6 months inactivity) flag and open ACA
    if (this.props.paChatbot?.enableNewUserWelcomeMsg && this.state.popupACA) {
      const brokerRegDt = this.props.userProfile?.brokerRegDt;
      const today = new Date().toISOString().slice(0, 10);
      const lastLogin = new Date(this.props.userProfile?.userLastLoginTime || '');
      let dated6MonthsAgo = new Date();
      const inactivityMonthCount = this.props.paChatbot?.inactivityMonthCount || 6;
      dated6MonthsAgo.setMonth(dated6MonthsAgo?.getMonth() - inactivityMonthCount);
      // Unix Timestamp
      const ts6MonthsAgo = Math.round(dated6MonthsAgo?.getTime() / 1000);
      const tsLastLogin = Math.round(lastLogin?.getTime() / 1000);
      // Check its a new user OR check user is inactive for more than 6 months or not
      if (brokerRegDt === today || tsLastLogin < ts6MonthsAgo) {
        window.gAcaProps = Object.assign({}, window.gAcaProps, {
          isNewPtbUser: true,
        });
        sessionStorage.setItem('gAcaProps', JSON.stringify(window.gAcaProps));
        const delayTimeout =
          this.props.paChatbot?.acaOpenDelayTimeout || false ? this.props.paChatbot.acaOpenDelayTimeout : 2000;
        setTimeout(() => {
          this.openACAUI(); // Start the timer & open ACA
        }, delayTimeout);
      }
    }

    if (this.state.reconnectLP === true && this.props?.enableLPReconnect) {
      const delayTimeout =
        this.props.paChatbot?.acaOpenDelayTimeout || false ? this.props.paChatbot.acaOpenDelayTimeout : 2000;
      setTimeout(() => {
        this.openACAUI(); // Start the timer & open ACA
      }, delayTimeout);
    }
  };

  render() {
    if (this.props.isChatBotEnabled) {
      this.checkPAShouldBeEnabled();
      // Check producer assistant is enabled
      if (this.enablePA) {
        if (this.props.paChatbot?.enableACA && this.props.paChatbot?.scriptListForACA) {
          this.renderACAUI();
        }
      }
    }
    return null;
  }
}

PAChatbot.propTypes = {
  paChatbot: PropTypes.object,
  isSimulation: PropTypes.bool,
  enabledModules: PropTypes.object,
  bpUserInfo: PropTypes.object,
  config: PropTypes.object,
  isProspectiveBroker: PropTypes.bool,
  isAdminPage: PropTypes.bool,
  userProfile: PropTypes.object,
  isChatBotEnabled: PropTypes.bool,
  enableLPReconnect: PropTypes.bool,
  passUserDetails: PropTypes.bool,
  encryptedTaxId: PropTypes.string,
  encryptedUserID: PropTypes.string,
  loggedInUserId: PropTypes.string,
  loggedInUserFName: PropTypes.string,
  loggedInUserLName: PropTypes.string,
  loggedInUserEmail: PropTypes.string,
  loggedInUserPhone: PropTypes.string,
  associatedStates: PropTypes.array,
  enableChatbotForUser: PropTypes.array,

  hideSidebar: PropTypes.func,
  showSidebar: PropTypes.func,
};

const mapDispatchToProps = dispatch => {
  return {
    hideSidebar: bindActionCreators(appSidebarActions, dispatch).hideSidebar,
    showSidebar: bindActionCreators(appSidebarActions, dispatch).showSidebar,
  };
};

function mapStateToProps(state, ownProps) {
  const passUserDetails = ownProps?.flags?.passUserDetailsInChatbotPayload === true;
  const enableLPReconnect = ownProps?.flags?.ChatbotLPReconnect === true;
  const enableChatbotForUser = ownProps?.flags?.enableChatbotForUser || [];

  return {
    isChatBotEnabled: state.homeReducers?.bpBrandFeatures?.features?.chatBot?.enable || false, // Brand Configs
    config: state.homeReducers?.config?.data,
    enabledModules: state.homeReducers?.userAccessModules,
    bpUserInfo: state.homeReducers?.bpUserInfo,
    isSimulation:
      (state.homeReducers.bpUserInfo?.roles?.canSimulate && state.homeReducers.bpUserInfo?.isSimulation) || false,
    paChatbot: state.homeReducers.config?.data?.features?.paChatbot || false,
    userProfile: state.homeReducers.bpUserInfo?.profileObj?.profile || {},
    isProspectiveBroker: state.homeReducers?.bpUserInfo?.roles?.isProspectiveBroker || false,
    isAdminPage:
      (state.homeReducers.bpUserInfo?.isInternalUser && !state.homeReducers.bpUserInfo?.isSimulation) || false,

    // DC4E-8606: enable chatbot for user types
    enableChatbotForUser: enableChatbotForUser,

    // BPP-144601: adding fallback for mpt changes
    passUserDetails: passUserDetails,
    enableLPReconnect: enableLPReconnect,
    encryptedTaxId: passUserDetails
      ? state.homeReducers.bpUserInfo?.profileObj?.profile?.producer?.encryptedTaxId || ''
      : undefined,
    encryptedUserID: passUserDetails
      ? state.homeReducers.bpUserInfo?.profileObj?.encryptedUserId_Aes256 || ''
      : undefined,
    loggedInUserId: passUserDetails ? state.homeReducers.bpUserInfo?.profileObj?.profile?.userId || '' : undefined,
    loggedInUserFName: passUserDetails
      ? state.homeReducers.bpUserInfo?.profileObj?.profile?.userFirstName || ''
      : undefined,
    loggedInUserLName: passUserDetails
      ? state.homeReducers.bpUserInfo?.profileObj?.profile?.userLastName || ''
      : undefined,
    loggedInUserEmail: passUserDetails
      ? state.homeReducers.bpUserInfo?.profileObj?.profile?.producer?.emailAddress || ''
      : undefined,
    loggedInUserPhone: passUserDetails
      ? state.homeReducers.bpUserInfo?.profileObj?.profile?.producer?.phoneNumber || ''
      : undefined,
    associatedStates: passUserDetails
      ? state.homeReducers.bpUserInfo?.profileObj?.profile?.producer?.appointedStates || []
      : undefined,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PAChatbot);